// extracted by mini-css-extract-plugin
module.exports = {"sticky-content":"_-web-client-js-react-components-___StickyWithScrollBack-module__sticky-content___nTAcj"};